import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [tenant, setTenant] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      const t = await api.get("/tenant/me");
      setTenant(t.data);
    } catch {
      setUser(false);
      setTenant(null);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data);
    const t = await api.get("/tenant/me");
    setTenant(t.data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data?.access_token) localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data);
    const t = await api.get("/tenant/me");
    setTenant(t.data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    setTenant(null);
  };

  return (
    <AuthContext.Provider value={{ user, tenant, setTenant, login, register, logout, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
